import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogConfirmComponent } from './dialog-confirm.component';

@NgModule({
  declarations: [DialogConfirmComponent],
  imports: [CommonModule, AngularMaterialModule],
  exports: [DialogConfirmComponent],
})
export class DialogConfirmModule {}
